import './App.scss';
import '@op/opds.styles/css/text.css';
import { createHashRouter, Navigate, RouterProvider } from 'react-router';
import routes from './messages/routes';
import LandingPage from './components/LandingPage';
import CourseWrapper from './components/CourseWrapper';

export const routerConfig = [
  {
    index: true,
    element: <LandingPage showTab={0} />,
  },
  // register all language versions for routes
  ...Object.values(routes).map((routeLocale) => ({
    path: routeLocale.coursePage,
    Component: CourseWrapper,
  })),
  ...Object.values(routes).map((routeLocale) => ({
    path: routeLocale.courses,
    element: <LandingPage showTab={1} />,
  })),
  {
    path: '*',
    element: <Navigate to="/" />,
  },
];

const router = createHashRouter(routerConfig);

const App = (): JSX.Element => {
  return <RouterProvider router={router} />;
};

export default App;
